import Slider from '@vueform/slider';
import '@vueform/slider/themes/default.css';

export default defineNuxtPlugin(async (nuxtApp) => {
    nuxtApp.vueApp.component('Slider', Slider);
})

